import React, { useEffect } from 'react';
import Input from '@components/common/input';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useForm } from '@hooks/helpers/useForm';
import { FormProvider } from 'react-hook-form';
import FormField from '@components/form_field';
import useModalContext from '@hooks/context/useModalContext';
import Textarea from '@components/common/textarea';
import Checkbox from '@components/common/checkbox';

const SaveAgreementModal = () => {
    const { handleChangeDisable, isDisableSubmit, changeModalData } = useModalContext();
    const form = useForm({
        defaultValues: {
            version: '',
            summary: '',
            is_primary: false
        }
    });
    const watch = form.watch();

    useEffect(() => {
        if (!form.formState.isValid !== isDisableSubmit) {
            handleChangeDisable(!form.formState.isValid);
        }
    }, [watch]);

    useEffect(() => {
        changeModalData(form.getValues());
    }, [watch.is_primary, watch.version, watch.summary]);

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4">Save new version</Typography>
            <FormProvider {...form}>
                <div className={styles.content}>
                    <FormField
                        name="version"
                        renderComponent={(props) => (
                            <Input
                                placeholder="Enter the agreement version"
                                full
                                label="Version"
                                {...props}
                            />
                        )}
                        rules={{ required: true }}
                    />
                    <FormField
                        name="summary"
                        renderComponent={(props) => (
                            <Textarea
                                full
                                label="Summary"
                                placeholder="Provide the summary of changes made"
                                {...props}
                            />
                        )}
                        rules={{ required: true }}
                    />
                    <FormField<boolean>
                        name="is_primary"
                        renderComponent={({ onChange, value }) => {
                            return (
                                <div className={styles.row}>
                                    <Checkbox checked={value} onClick={() => onChange(!value)} />
                                    Set as default
                                </div>
                            );
                        }}
                    />
                </div>
            </FormProvider>
        </div>
    );
};

export default SaveAgreementModal;
